export default __webpack_public_path__ + "static/media/Fuzzy_Airplane.d1be5560.mp3";